var exports = {
  "D": "BackToRepositorySelectionButton__Txhgro",
};

module.exports = exports;
